import { gql } from '@apollo/client';
import { FRAGMENT_ACCESS_GROUP } from './fragment.accessGroup';

export const FRAGMENT_ACCESS_GROUP_WITH_ACCESS_CONTROLS = gql`
    ${FRAGMENT_ACCESS_GROUP}
    fragment accessGroupWithAccessControls on AccessGroup {
        ...accessGroup
        accessControls {
            key
            isAllowed
        }
    }
`;
